module.exports = __webpack_public_path__ + "fonts/subset-Axiforma-LightItalic.59392a9.woff";